import React, { forwardRef } from 'react';
import MaskedInput from 'react-text-mask';

const CPFMaskInput = forwardRef(
  ({ value, onChange, size, className, ...rest }, ref) => {
    const cpfMask = [
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '.',
      /\d/,
      /\d/,
      /\d/,
      '-',
      /\d/,
      /\d/,
    ];

    // Constrói a classe CSS baseada no size
    let inputClassName = className || 'form-control';
    if (size === 'sm') {
      inputClassName += ' form-control-sm';
    } else if (size === 'lg') {
      inputClassName += ' form-control-lg';
    }

    return (
      <MaskedInput
        mask={cpfMask}
        value={value}
        onChange={onChange}
        render={(inputRef, props) => (
          <input
            ref={inputRef}
            {...props}
            {...rest}
            className={inputClassName}
          />
        )}
      />
    );
  }
);

export default CPFMaskInput;
